// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { injectColorSchemeScript } from './utils/color-scheme-script';
import registerServiceWorker from './registerServiceWorker';

// Inject the color scheme script to prevent flashing
injectColorSchemeScript();

// Register service worker for PWA functionality
registerServiceWorker();

// Development helper for Postman testing
if (process.env.NODE_ENV === 'development') {
  import('./utils/getTokenForTesting').then(module => {
    window.getTokenForTesting = module.getTokenForTesting;
    //console.log('%c🔧 Development Helper Available', 'color: #4CAF50; font-weight: bold; font-size: 14px;');
    //console.log('%cRun: await getTokenForTesting()', 'color: #2196F3; font-size: 12px;');
    //console.log('%cThis will copy your auth token to clipboard for Postman testing', 'color: #666; font-size: 11px;');
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);